<div class="ses-oynatici">
    <!-- Afiş: Statik dalga formu + canlı spectrum canvas üst üste -->
    <div class="afis" (click)="oynat()">
        <!-- Statik dalga formu (arkaplan) -->
        <svg class="dalga-formu" viewBox="0 0 120 40" preserveAspectRatio="none">
            <rect x="2" y="12" width="2.5" height="16" rx="1" opacity="0.5"/>
            <rect x="7" y="6" width="2.5" height="28" rx="1" opacity="0.7"/>
            <rect x="12" y="10" width="2.5" height="20" rx="1" opacity="0.6"/>
            <rect x="17" y="4" width="2.5" height="32" rx="1" opacity="0.9"/>
            <rect x="22" y="14" width="2.5" height="12" rx="1" opacity="0.4"/>
            <rect x="27" y="8" width="2.5" height="24" rx="1" opacity="0.8"/>
            <rect x="32" y="2" width="2.5" height="36" rx="1" opacity="1"/>
            <rect x="37" y="10" width="2.5" height="20" rx="1" opacity="0.6"/>
            <rect x="42" y="6" width="2.5" height="28" rx="1" opacity="0.7"/>
            <rect x="47" y="14" width="2.5" height="12" rx="1" opacity="0.45"/>
            <rect x="52" y="4" width="2.5" height="32" rx="1" opacity="0.85"/>
            <rect x="57" y="10" width="2.5" height="20" rx="1" opacity="0.55"/>
            <rect x="62" y="8" width="2.5" height="24" rx="1" opacity="0.75"/>
            <rect x="67" y="12" width="2.5" height="16" rx="1" opacity="0.5"/>
            <rect x="72" y="2" width="2.5" height="36" rx="1" opacity="0.95"/>
            <rect x="77" y="6" width="2.5" height="28" rx="1" opacity="0.7"/>
            <rect x="82" y="14" width="2.5" height="12" rx="1" opacity="0.4"/>
            <rect x="87" y="8" width="2.5" height="24" rx="1" opacity="0.8"/>
            <rect x="92" y="10" width="2.5" height="20" rx="1" opacity="0.6"/>
            <rect x="97" y="4" width="2.5" height="32" rx="1" opacity="0.9"/>
            <rect x="102" y="12" width="2.5" height="16" rx="1" opacity="0.5"/>
            <rect x="107" y="6" width="2.5" height="28" rx="1" opacity="0.65"/>
            <rect x="112" y="10" width="2.5" height="20" rx="1" opacity="0.55"/>
        </svg>

        <!-- Canlı spectrum canvas (çalarken üzerine çizilir) -->
        <canvas #spectrumCanvas
                class="spectrum-canvas"
                width="400"
                height="100"></canvas>

        <!-- Büyük play/pause overlay -->
        <div class="afis-overlay">
            @if (sesObje?.paused == true || sesObje == null) {
                <i class="play circle outline icon"></i>
            } @else {
                <i class="pause circle outline icon"></i>
            }
        </div>

        <!-- Spectrum mod değiştir -->
        <button class="spectrum-mod-btn"
                (click)="spectrumModDegistir(); $event.stopPropagation();"
                [title]="spectrumModIsimleri[aktifSpectrumMod]">
            {{ spectrumModIsimleri[aktifSpectrumMod] }}
        </button>

        <!-- Altyazı butonu -->
        <button class="transkript-btn"
                (click)="altyaziToggle(); $event.stopPropagation();"
                [class.yukleniyor]="transkriptYukleniyor"
                [class.aktif]="altyaziAktif"
                title="Altyazı">
            @if (transkriptYukleniyor) {
                <i class="spinner loading icon"></i>
            } @else {
                <i class="closed captioning outline icon"></i>
            }
        </button>

        <!-- Altyazı overlay (film altyazısı gibi) -->
        @if (altyaziAktif && aktifAltyazi) {
            <div class="altyazi-overlay">
                <span class="altyazi-metin">{{ aktifAltyazi }}</span>
            </div>
        }
    </div>

    <!-- Alt kontrol barı -->
    <div class="kontrol-bar">
        <!-- Geri sar 10sn -->
        <button class="sar-btn" (click)="geriSar()" title="10sn geri">
            <i class="backward icon"></i>
        </button>

        <button class="oynat-btn" (click)="oynat()">
            @if (sesObje?.paused == true || sesObje == null) {
                <i class="play icon"></i>
            } @else {
                <i class="pause icon"></i>
            }
        </button>

        <!-- İleri sar 10sn -->
        <button class="sar-btn" (click)="ileriSar()" title="10sn ileri">
            <i class="forward icon"></i>
        </button>

        <div class="oynatici-govde">
            <!-- Progress track: buffer + zaman -->
            <div class="progress-wrapper">
                <div class="buffer-bar"
                     [style.width.%]="bufferYuzdesi"></div>
                <input type="range"
                       class="zaman-cubugu"
                       min="0"
                       [max]="sarkiSure"
                       [value]="aktifZaman"
                       [style.--ilerleme]="sarkiSure > 0 ? (aktifZaman / sarkiSure * 100) + '%' : '0%'"
                       (mousedown)="zamanKaydiriliyor=true;"
                       (change)="zamanKaydirildi($event)" />
            </div>
            <div class="zaman-bilgi">
                <span class="zaman aktif">{{ aktifZaman | minuteSeconds }}</span>
                <span class="zaman kalan">-{{ kalanSure | minuteSeconds }}</span>
                <span class="zaman toplam">{{ sarkiSure | minuteSeconds }}</span>
            </div>
        </div>

        <!-- Oynatma hızı -->
        <button class="hiz-btn" (click)="hizDegistir()" title="Oynatma hızı">
            {{ aktifHiz }}x
        </button>

        <div class="ses-kontrol">
            <button class="ses-btn" (click)="sessizTiklandi()">
                @if (sessiz || sesSeviyesi === 0) {
                    <i class="volume mute icon"></i>
                } @else if (sesSeviyesi < 0.5) {
                    <i class="volume down icon"></i>
                } @else {
                    <i class="volume up icon"></i>
                }
            </button>
            <input type="range"
                   class="ses-cubugu"
                   min="0"
                   max="1"
                   step="0.05"
                   [value]="sessiz ? 0 : sesSeviyesi"
                   [style.--ses-ilerleme]="(sessiz ? 0 : sesSeviyesi) * 100 + '%'"
                   (input)="sesSeviyesiDegisti($event)" />
        </div>
    </div>

    <!-- Transkript sonucu -->
    @if (transkriptGoster) {
        <div class="transkript-panel">
            <div class="transkript-baslik">
                <span><i class="closed captioning outline icon"></i> Yazıya Çevirme</span>
                <button class="transkript-kapat" (click)="transkriptKapat()">
                    <i class="close icon"></i>
                </button>
            </div>
            <div class="transkript-icerik">
                @if (transkriptYukleniyor) {
                    <span class="transkript-bekleniyor">Ses analiz ediliyor...</span>
                } @else {
                    {{ transkriptMetni }}
                }
            </div>
        </div>
    }
</div>
